export default __webpack_public_path__ + "static/media/Kairos_lab.40c1d547.png";